// 公共配置
export const BASE_URL = 'https://server.bookhome.resourse.cn/api';
